module.exports = "/_next/static/images/teachesLogo-c4529d4fcffe661a403c3f6ebc4a19c7.svg";